<template>
    <div class="ZIframe">
        <iframe
            v-if="url"
            ref="ZIframe"
            class="ZIframe-iframe"
            :src="url"
            frameborder="0"
            allowtransparency="true"
        ></iframe>
        <div
            v-else
            class="dsh-flex-row-center-center ZIframe-nodata"
        >
            <img
                :src="noData"
                alt="无数据"
            >
        </div>

        <Spin
            v-if="loading"
            size="large"
            fix
        ></Spin>
    </div>
</template>

<script>
    export default {
        name: "ZIframe",
        props: {
            url: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                noData: this.$imageSrcMap.app.nodata,
                loading: false
            };
        },
        computed: {
        },
        mounted () {
            this.init();
            window.addEventListener("message", this.onMessage);
        },
        methods: {
            init () {
                let iframe = this.$refs.ZIframe;
                if (!iframe) {
                    return;
                }
                this.loading = true;
                if (iframe.attachEvent) {
                    iframe.attachEvent("onreadystatechange", () => {
                        if (iframe.readyState === "complete" || iframe.readyState == "loaded") {
                            this.loadingEnd();
                        }
                    });
                } else {
                    iframe.addEventListener("load", () => {
                        this.loadingEnd();
                    }, false);
                }

            },
            loadingEnd () {
                this.loading = false;
            },
            /**
             * 在iframe页面使用举例：
             * let info = { "status": "success", type: "jumpPage", routerName: "home", params: {}, query: {} };
             * window.parent.postMessage(info, "*");
             *  */
            onMessage ({ data }) {
                if (data.status === "success") {
                    this.$emit("on-message", data);
                }
            },
            beforeDestroy () {
                window.removeEventListener("message", this.onMessage, true);
            }
        }
    };
</script>

<style lang="less">
    .ZIframe {
        display: flex;
        width: 100%;
        height: 100%;
        position: relative;
        &-iframe {
            flex: 1;
            overflow: auto;
        }
        &-nodata {
            width: 100%;
            height: 100%;
        }
   }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/ZIframe.vue